import { render, staticRenderFns } from "./StorageManageAdd.vue?vue&type=template&id=09150d1c&scoped=true"
import script from "./StorageManageAdd.vue?vue&type=script&lang=js"
export * from "./StorageManageAdd.vue?vue&type=script&lang=js"
import style0 from "./StorageManageAdd.vue?vue&type=style&index=0&id=09150d1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09150d1c",
  null
  
)

export default component.exports